/**
 * Titre de page + action principale (bouton à droite).
 * Réutilisé tel quel quand on ajoutera Clients / Factures.
 */
import type { ReactNode } from "react";

type PageHeaderProps = {
  title: string;
  action?: ReactNode;
};

export function PageHeader({ title, action }: PageHeaderProps) {
  return (
    <header className="mb-4 flex items-center justify-between gap-3">
      <h1 className="fx-title m-0 font-[Nunito] text-2xl text-indigo-950">{title}</h1>
      {action}
    </header>
  );
}
